import React from 'react';
import {BreadCrumbs} from '../components/common/bread-crumbs/BreadCrumbs';
import {SEOText} from '../components/g2/seo-text/SEOText';
import {SEOTextRevised} from '../components/g2/seo-text/SEOTextRevised';
import {LinkPiles} from '../components/common/linkpiles/LinkPiles';
import {PopularDestinations} from '../components/g2/popular-destinations/PopularDestinations';
import {PropertyTypes} from '../components/g2/property-types/PropertyTypes';
import {GreatPlacesToStay} from '../components/g2/great-places-to-stay/GreatPlacesToStay';
import DateModal from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../components/common/destination-urgency/AsyncDestinationUrgency';
import {AsyncDestinationInfographic} from '../components/common/destination-infographic/AsyncDestinationInfographic';
import {AsyncQuickSeRPFilters} from '../components/common/quick-serp-filters/AsyncQuickSeRPFilters';
import {AsyncReviews} from '../components/common/review/AsyncReviews';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import {BackToTopComponent} from '../components/common/back-to-top-button/BackToTopComponent';
import {AsyncTrustpilot} from '../components/common/trustpilot/AsyncTrustpilot';
import {AsyncRecentTravelerActivity} from '../components/common/recent-traveler-activity/AsyncRecentTravelerActivity';
import LazyLoad from '../components/common/lazy-image/react-lazyload';

export const Template = () => (
    <React.Fragment>
        <main className="app-main">
            <BreadCrumbs />
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncRecentTravelerActivity /></LazyLoad>)}
            {withErrorBoundary(<AsyncDestinationUrgency />)}
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncQuickSeRPFilters /></LazyLoad>)}
            <PopularDestinations />
            <PropertyTypes />
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncTrustpilot /></LazyLoad>)}
            <GreatPlacesToStay />
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncReviews /></LazyLoad>)}
            {withErrorBoundary(<AsyncDestinationInfographic />)}
            <SEOTextRevised />
            <SEOText />
            <LinkPiles />
            <BackToTopComponent />
            <DateModal />
        </main>
        <MmgLinks />
    </React.Fragment>
);
